import React, { useEffect, useState } from 'react';
import { FaChevronUp } from 'react-icons/fa';
import './ScrollToTopButton.css'; 


const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 300) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <button 
      className={`scroll-to-top ${visible ? 'show' : ''}`} 
      onClick={scrollToTop}
    >
     <FaChevronUp />
    </button>
  );
};
export default ScrollToTopButton;
